import axios from "axios";

const baseUrl = process.env.REACT_APP_API_URL;
const config = {
  headers: { Authorization: "" },
};


export const toggleNewTaskModal = (data) => {
  return async (dispatch) => {
    if (!data.title) {
      dispatch({
        type: "toggle-new-task-modal",
        payload: {
          title: '',
          value: data.value,
          assignee: data.assignee || null,
        },
      });
      return;
    }

    let res;
    try {
      dispatch({
        type: "toggle-new-task-modal",
        payload: {
          title: data.title,
          value: true,
          assignee: data.assignee || null,
        },
      });
    } catch (error) {
      console.log(error);
    }
  };
};

export const toggleNewProjectModal = (data) => {
  return async (dispatch) => {
    if (!data.title) {
      dispatch({
        type: "toggle-new-project-modal",
        payload: {
          value: data.value,
          team: data?.team || ''
        },
      });
      return;
    }
  }
}

export const toggleNewTeamChatsModal = (data) => {
  return async (dispatch) => {
    if (!data.title) {
      dispatch({
        type: "toggle-new-teams-chats-modal",
        payload: {
          value: data.value,
          isTeams: data.isTeams
        },
      });
      return;
    }
  }
}

export const toggleWorkspaceFieldsModal = (data, projectId, allowedProjectIds) => {
  return async (dispatch) => {
    dispatch({
      type: "toggle-workspace-fields-modal",
      payload: {
        value: data,
        projectId: projectId || '',
        allowedProjectIds: allowedProjectIds || null,
      },
    });
    return;
  }
}

export const toggleDuplicateProjectModal = (data, proj) => {
  return async (dispatch) => {
    dispatch({
      type: "toggle-duplicate-project-modal",
      payload: {
        value: data,
        project: proj || {}
      },
    });
    return;
  }
}

export const toggleWorkspaceTagsModal = (data) => {
  return async (dispatch) => {
    dispatch({
      type: "toggle-workspace-tags-modal",
      payload: {
        value: data,
      },
    });
    return;
  }
}

export const toggleInviteToProjectModal = (data, projectId) => {
  return async (dispatch) => {
    dispatch({
      type: "toggle-invite-to-project-modal",
      payload: {
        value: data,
        projectId: projectId || '',
      },
    });
    return;
  }
}

export const toggleInviteToWorkspaceModal = (data) => {
  return async (dispatch) => {
    dispatch({
      type: "toggle-invite-to-workspace-modal",
      payload: {
        value: data,
      },
    });
    return;
  }
}

export const toggleEditProjectDetailsModal = (data, proj) => {
  return async (dispatch) => {
    dispatch({
      type: "toggle-edit-project-details-modal",
      payload: {
        value: data,
        project: proj || {}
      },
    });
    return;
  }
}

export const togglePortfolioModal = (show, portfolioId = null, projectId = null) => {
  return async (dispatch) => {
    dispatch({
      type: "toggle-portfolio-modal",
      payload: {
        portfolioId: portfolioId,
        projectId: projectId,
        value: show
      },
    });
    return;
  }
}

export const toggleProjectInvitesBanner = (projectId = null, members = []) => {
  return async (dispatch) => {
    dispatch({
      type: "toggle-project-invites-banner",
      payload: {
        members: members,
        projectId: projectId,
      },
    });
    return;
  }
}

export const toggleEditCustomFieldModal = (data, field, proj) => {
  return async (dispatch) => {
    dispatch({
      type: "toggle-edit-customfield-modal",
      payload: {
        value: data,
        customField: field || {},
        project: proj || {},
      },
    });
    return;
  }
}

export const toggleDuplicateTaskModal = (data, task) => {
  return async (dispatch) => {
    dispatch({
      type: "toggle-duplicate-task-modal",
      payload: {
        value: data,
        task: task || {}
      },
    });
    return;
  }
}

export const toggleCustomChartModal = (show, dashboardId, dashboardTitle, reportId) => {
  return async (dispatch) => {
    dispatch({
      type: "toggle-custom-horizontal-chart-modal",
      payload: {
        show: show,
        dashboardId,
        dashboardTitle,
        reportId
      },
    });
    return;
  }
}

export const toggleFullScreenChartModal = (data, dashboardId, reportId) => {
  return async (dispatch) => {
    dispatch({
      type: "toggle-chart-fullscreen-modal",
      payload: {
        value: data,
        dashboardId,
        reportId,
      },
    });
    return;
  }
}